import {Store} from '../classes/store';
import {Injectable} from '@angular/core';
import {ApiLegacyService} from '../../../services/api/api.service';
import { BuildingTemplate } from '../../../resources/building-template/building-template.interface';

@Injectable({
  providedIn: 'root'
})
export class BuildingTemplateStore extends Store<BuildingTemplate> {

  /** Constructor. */
  constructor(
    private api: ApiLegacyService
  ) {
    super();
  }

  load() {
    this.api.getBuildingTemplates().subscribe(buildingTemplates => {
      this.setState(buildingTemplates);
    });

    return this.state$;
  }
}
